<template>
  <v-textarea
    :height="height"
    :label="$t('请输入审批意见')"
    v-model="note"
    :clearable="true"
    solo
    rows="30"
  ></v-textarea>
</template>

<script>
import msgbus from '../../msgBus'
import { styleNo } from '../../config/BottomBtn'
import swal from 'sweetalert2'

export default {
  name: 'eDS-FlowFinish',
  components: {},
  data() {
    return {
      title: this.$t('流程-直接完成'),
      bottomButtons: [
        {
          primary: true,
          title: this.$t('直接完成'),
          style: styleNo[1],
          func: this.onConfirm,
          params: '',
        },
      ],
      flowInfo: null,
      note: '',
    }
  },
  computed: {
    height() {
      return `calc(${window.innerHeight}px - 48px - 36px ` + ')'
    },
  },
  methods: {
    //确认
    onConfirm() {
      swal.fire({
        text: '',
        title: this.$t('流程已直接完成'),
        type: 'success',
        showConfirmButton: false,
        timer: 2000,
      })
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitle(this.title)
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(true)
      msgbus.vm.setBottomBtn({ value: this.bottomButtons })
      msgbus.vm.setContentHeight({
        value: `calc(${window.innerHeight}px - 48px - 36px ` + ')',
      })
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }

    // 读取路由参数：流程信息\流程所在租户tid
    this.flowInfo = this.$route.params.flowInfo
    this.flowTid = this.$route.params.flowTid
    this.title = this.flowInfo.name

    // 切换界面样式
    this.changeView()
  },
  mounted() {},
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
  },
}
</script>

<style lang="scss">
.eds-flow-finish-root {
}
</style>
